/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const DevkitPortalBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><g fillRule="evenodd" clipRule="evenodd"><path d="M10.396 18.509c0 .322-.301.56-.607.458-2.286-.769-4.048-2.833-4.603-5.257-.877-3.8 1.426-7.63 5.21-8.517 3.785-.887 7.542 1.498 8.42 5.299.829 3.592-1.209 7.343-4.631 8.477-.306.102-.607-.137-.607-.46v-2.564c0-.196.115-.371.286-.468a3.904 3.904 0 0 0 1.606-1.768c.877-1.941.027-4.412-1.893-5.3-1.92-.887-4.195-.027-5.073 1.914-.833 1.844-.109 4.163 1.609 5.153a.547.547 0 0 1 .284.467v2.566Z" /><path d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10Zm0 2c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z" /></g></svg>);
const DevkitPortal = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={DevkitPortalBase} {...rest} ref={ref} />);
export default DevkitPortal;